<!-- Floating badge anchored to the focused field (Grammarly-style). -->
<button
  *ngIf="activeTarget && badgePos"
  type="button"
  class="proofread-badge"
  [class.is-checking]="status === 'checking'"
  [class.has-suggestions]="status === 'suggestions'"
  [class.is-clean]="status === 'clean'"
  [class.is-error]="status === 'error'"
  [style.top.px]="badgePos.top"
  [style.left.px]="badgePos.left"
  title="Proofread this text"
  (mousedown)="$event.preventDefault()"
  (click)="onBadgeClick($event)">
  <span class="badge-spinner" *ngIf="status === 'checking'"></span>
  <span class="badge-count" *ngIf="status === 'suggestions'">{{ edits.length }}</span>
  <svg *ngIf="status === 'clean'" class="badge-icon" viewBox="0 0 24 24" width="14" height="14" aria-hidden="true">
    <path d="M5 13l4 4L19 7" fill="none" stroke="currentColor" stroke-width="2.5" stroke-linecap="round" stroke-linejoin="round"/>
  </svg>
  <svg *ngIf="status === 'idle' || status === 'error'" class="badge-icon" viewBox="0 0 24 24" width="15" height="15" aria-hidden="true">
    <path d="M12 3l1.6 4.2L18 8.8l-4.4 1.6L12 14.6l-1.6-4.2L6 8.8l4.4-1.6L12 3z" fill="currentColor"/>
    <circle cx="18.5" cy="16.5" r="1.6" fill="currentColor"/>
  </svg>
</button>

<!-- Suggestions panel. -->
<div
  *ngIf="panelOpen && panelPos"
  class="proofread-panel"
  [style.top.px]="panelPos.top"
  [style.bottom.px]="panelPos.bottom"
  [style.right.px]="panelPos.right">

  <div class="panel-header">
    <span class="panel-brand">
      <svg class="panel-brand-icon" viewBox="0 0 24 24" width="14" height="14" aria-hidden="true">
        <path d="M12 3l1.6 4.2L18 8.8l-4.4 1.6L12 14.6l-1.6-4.2L6 8.8l4.4-1.6L12 3z" fill="currentColor"/>
        <circle cx="18.5" cy="16.5" r="1.6" fill="currentColor"/>
      </svg>
      <span class="panel-title">Proofread</span>
    </span>
    <button type="button" class="panel-close" (click)="closePanel()" title="Close" aria-label="Close">
      <svg viewBox="0 0 24 24" width="14" height="14" aria-hidden="true">
        <path d="M6 6l12 12M18 6L6 18" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round"/>
      </svg>
    </button>
  </div>

  <div class="panel-body">
    <div *ngIf="status === 'checking'" class="panel-state">
      <span class="badge-spinner dark"></span> Checking your text…
    </div>

    <div *ngIf="status === 'error'" class="panel-state error">
      Couldn’t check right now. Please try again.
    </div>

    <div *ngIf="status === 'clean'" class="panel-state clean">
      <span class="state-check">
        <svg viewBox="0 0 24 24" width="16" height="16" aria-hidden="true">
          <path d="M5 13l4 4L19 7" fill="none" stroke="currentColor" stroke-width="2.5" stroke-linecap="round" stroke-linejoin="round"/>
        </svg>
      </span>
      {{ appliedCount > 0 ? 'All suggestions applied.' : 'Looks good — no issues found.' }}
    </div>

    <ng-container *ngIf="status === 'suggestions'">
      <div class="panel-actions-top">
        <span class="suggestion-count">{{ edits.length }} suggestion{{ edits.length === 1 ? '' : 's' }}</span>
        <button type="button" class="btn-apply-all" (click)="applyAll()">Apply all</button>
      </div>

      <ul class="suggestion-list">
        <li class="suggestion" *ngFor="let edit of edits; let i = index">
          <div class="suggestion-diff">
            <span class="chip chip-before">{{ edit.before }}</span>
            <svg class="chip-arrow" viewBox="0 0 24 24" width="14" height="14" aria-hidden="true">
              <path d="M5 12h14M13 6l6 6-6 6" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
            </svg>
            <span class="chip chip-after">{{ edit.after }}</span>
          </div>
          <div class="suggestion-reason" *ngIf="edit.reason">{{ edit.reason }}</div>
          <div class="suggestion-controls">
            <button type="button" class="btn-accept" (click)="applyEdit(edit, i)">Accept</button>
            <button type="button" class="btn-dismiss" (click)="dismissEdit(i)">Dismiss</button>
          </div>
        </li>
      </ul>
    </ng-container>
  </div>
</div>
